import i18n from "../../i18n";
export class NotFoundError extends Error {
  constructor(message) {
    super(message);
    if (!message) {
      this.message = i18n.t("The resource that has been requested not found.");
    }
    this.name = "NotFoundError";
    this.status_code = 404;
  }
}
